module.exports = __webpack_public_path__ + "img/mobile-footer-1.20ca0c93.png";